import React from "react"
import badge from "badges/universe-master.svg"
import { BadgeImage } from "backpack/badges/styled"

const UniverseMaster = props => <BadgeImage src={badge} {...props} />

export default UniverseMaster
